import { api } from '../../../plugins/axios';

export default class LocationGroup {
	id = undefined;
	name = '';
	cities = [];
	isLocal = false;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	get cities_ids() {
		return this.cities.map((city) => city.city_id);
	}

	static fetchGroups = async (params = {}) => {
		try {
			const { data: responseData } = await api.get('/shipping/regions', {
				params,
			});

			const data = responseData.result.regions.data;

			return {
				data: data.map((obj) => {
					return new LocationGroup({ id: obj.id, name: obj.name, cities: obj.cities });
				}),
				totalRecords: responseData.result.regions.total,
			};
		} catch (e) {
			console.log(e);
		}
	};

	async create() {
		const data = await api.post(`/shipping/regions`, {
			name: this.name,
			cities_id: this.cities_ids,
		});
		this.id = data.data.result.region.id;
		this.isLocal = false;
	}

	async update() {
		await api.put(`/shipping/regions/${this.id}`, {
			name: this.name,
			cities_id: this.cities_ids,
		});
	}

	async save() {
		if (!this.isLocal) {
			await this.update();
		} else {
			await this.create();
		}
	}

	remove() {
		if (this.isLocal) return;
		return api.delete(`/shipping/regions/${this.id}`);
	}
}
